module.exports = __webpack_public_path__ + "img/liferecad_logo.eaab5cfc.svg";